import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ArrowLeft, MapPin } from 'lucide-react';
const allDestinations = [{
  name: 'Vietnam',
  image: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&q=80&w=800',
  desc: 'Land of the Blue Dragon'
}, {
  name: 'Dubai',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea936a7fe48?auto=format&fit=crop&q=80&w=800',
  desc: 'City of Gold'
}, {
  name: 'Mumbai',
  image: 'https://images.unsplash.com/photo-1566552881560-0be862a7c445?auto=format&fit=crop&q=80&w=800',
  desc: 'The City of Dreams'
}, {
  name: 'Dwarka',
  image: 'https://images.unsplash.com/photo-1628668923083-ea798c800539?auto=format&fit=crop&q=80&w=800',
  desc: 'Kingdom of Lord Krishna'
}, {
  name: 'Delhi',
  image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?auto=format&fit=crop&q=80&w=800',
  desc: 'Heart of India'
}, {
  name: 'Rishikesh',
  image: 'https://images.unsplash.com/photo-1592639296346-560c37a8f7f4?auto=format&fit=crop&q=80&w=800',
  desc: 'Yoga Capital of the World'
}, {
  name: 'Pune',
  image: 'https://images.unsplash.com/photo-1572883454114-1cf0031a021e?auto=format&fit=crop&q=80&w=800',
  desc: 'Oxford of the East'
}, {
  name: 'Kashmir',
  image: 'https://images.unsplash.com/photo-1595867865332-acd54364542b?auto=format&fit=crop&q=80&w=800',
  desc: 'Paradise on Earth'
}, {
  name: 'Dehradun',
  image: 'https://images.unsplash.com/photo-1589404867376-747370857502?auto=format&fit=crop&q=80&w=800',
  desc: 'Valley of Doon'
}, {
  name: 'Mussoorie',
  image: 'https://images.unsplash.com/photo-1626621341120-20d0812246d6?auto=format&fit=crop&q=80&w=800',
  desc: 'Queen of the Hills'
}];
export function TravelStories() {
  return <div className="bg-zen-bg min-h-screen text-zen-text" data-id="element-207">
      <Navbar data-id="element-208" />
      <main className="pt-32 pb-20 px-6" data-id="element-209">
        <div className="max-w-7xl mx-auto" data-id="element-210">
          <a href="/" className="inline-flex items-center gap-2 text-zen-text/60 hover:text-zen-accent mb-8 transition-colors" data-id="element-211">
            <ArrowLeft className="w-4 h-4" data-id="element-212" /> Back to Home
          </a>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-moon-dance mb-6" data-id="element-213">
            Wanderlust Chronicles
          </motion.h1>

          <p className="text-xl text-zen-text/70 mb-16 leading-relaxed max-w-2xl" data-id="element-214">
            Every destination leaves a mark. Here are the places that have
            shaped my perspective and filled my soul with wonder.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-215">
            {allDestinations.map((place, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.05
          }} className="group relative h-[300px] rounded-3xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-500" data-id="element-216">
                <img src={place.image} alt={place.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-217" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90" data-id="element-218" />

                <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-219">
                  <div className="flex items-center gap-2 text-white/80 text-sm mb-2" data-id="element-220">
                    <MapPin className="w-4 h-4" data-id="element-221" />
                    <span className="uppercase tracking-wider" data-id="element-222">
                      {place.name}
                    </span>
                  </div>
                  <h3 className="text-2xl font-moon-dance text-white" data-id="element-223">
                    {place.desc}
                  </h3>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-224" />
    </div>;
}